module.exports = __webpack_public_path__ + "media/images/new/background_great_camping_map-03597aa6461886404f759325277ab12c.jpg";